import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import toast from "react-hot-toast";

function VerifyUserModal({ show, setShow, VerifyUser, id, prePopulatedEmail }) {
  const { i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    setLoading(true);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error(
        i18n.language === "ar"
          ? "!يرجى إدخال بريد إلكتروني صحيح"
          : "Please enter a valid email!"
      );
      setLoading(false);
      return;
    }

    try {
      await VerifyUser(email); // wait for verification to finish
    } catch (error) {
      console.error("Verification error:", error);
    } finally {
      setLoading(false); // hide loader after process completes
    }
  };

  useEffect(() => {
    setEmail(prePopulatedEmail);
  }, [prePopulatedEmail]);
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      size="lg"
      className="modal fade error-modal p-2 p-md-0 montserrat-font"
      centered
    >
      <Modal.Body>
        <div
          id={id}
          className="d-flex"
          style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
        >
          <div className="flex-col w-100">
            <div className="pt-2">
              <div className="row">
                <div
                  className="text-start"
                  style={{
                    color: "#777777",
                    fontSize: "16px",
                    direction: i18n.language === "ar" ? "rtl" : "ltr",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                    }}
                  >
                    {i18n.language === "ar"
                      ? "يرجى التحقق من بريدك الإلكتروني"
                      : "Please verify your email"}
                  </p>
                  <div className="flex-col w-100">
                    <p
                      className="mb-1"
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      {i18n.language === "ar" ? "البريد الإلكتروني" : "Email"}
                    </p>
                    <input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="custom-input-payment"
                      placeholder={
                        i18n.language === "ar"
                          ? "you@example.com"
                          : "johndoe@myemail.com"
                      }
                      style={{
                        border: "1px solid #9A9A9A",
                        width: "100%",
                        padding: "13px",
                        borderRadius: "2px",
                        outline: "none",
                        boxShadow: "none",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col mt-4">
                <motion.button
                  onClick={handleVerify}
                  whileHover={{ scale: 1.03, opacity: 0.9 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  style={{
                    outline: "none",
                    width: "100%",
                    backgroundColor: "#C6AC96",
                    color: "white",
                    fontSize: "16px",
                    fontWeight: "500",
                    border: "none",
                    height: "45px",
                    borderRadius: "2px",
                    opacity: loading ? 0.6 : 1,
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></span>
                  ) : i18n.language === "ar" ? (
                    "تحقق"
                  ) : (
                    "Verify"
                  )}
                </motion.button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default VerifyUserModal;
